import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import tagsView from './modules/tagsView'
import dict from './modules/dict'

// default router permission control
// import permission from './modules/permission'
import permission from './modules/async-router'
import auditReminder from './modules/auditReminder'
import csMessageReminder from './modules/csMessageReminder'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    tagsView,
    dict,
    permission,
    auditReminder,
    csMessageReminder
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})
